import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { createBrowserRouter, Outlet, RouterProvider } from "react-router-dom";
import { I18nextProvider } from "react-i18next";
import i18n from "i18next";

import Home from "./pages/home/home";
import Navbar from "./components/navbar/navbar";
import Footer from "./components/footer/footer";
import NotFound from "./pages/notfound/notfound";
import Template from "./pages/template/template";
import Kontakt from "./pages/kontakt/kontakt";
import Entdecken from "./pages/entdecken/entdecken";
import Anfragen from "./pages/anfragen/anfragen";
import Maintenance from "./pages/maintenance/maintenance";

import translationDE from "./translations/de.json";
import translationIT from "./translations/it.json";
import translationEN from "./translations/en.json";

const isMaintenanceMode = false;
const lang = window.location.pathname.substring(1, 3);

i18n.init({
  interpolation: { escapeValue: false },
  lng: lang,
  resources: {
    de: {
      translation: translationDE,
    },
    it: {
      translation: translationIT,
    },
    en: {
      translation: translationEN,
    },
  },
});

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

function App() {

  const Layout = () => {
    return (
      <div className="site">
        <Navbar />
        <ScrollToTop />
        <Outlet />
        <Footer />
      </div>
    )
  }

  const router = createBrowserRouter([
    {
      path: "/:lang",
      element: isMaintenanceMode ? <Maintenance /> : <Layout />,
      children: isMaintenanceMode ? [] : [
        {
          path: "/:lang",
          element: <Home />,
        },
        {
          path: "/:lang/kontakt",
          element: <Kontakt />,
        },
        {
          path: "/:lang/anfragen",
          element: <Anfragen />,
        },
        {
          path: "/:lang/datenschutz",
          element: <Template />,
        },
        {
          path: "/:lang/impressum",
          element: <Template />,
        },
        {
          path: "/:lang/entdecken",
          element: <Entdecken />,
        }
      ]
    },
    {
      path: "*",
      element: isMaintenanceMode ? <Maintenance /> : <NotFound />,
    },
  ]);

  return (
    <I18nextProvider i18n={i18n}>
      <RouterProvider router={router} />
    </I18nextProvider>
  );
}

export default App;
